//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Base64 } from '@/tools'
import { mapGetters } from 'vuex'
import { jssdk } from '@runwork/runwork-help'
import md5 from 'blueimp-md5'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  data() {
    return {
      fileValue: '',
      rule: {
        custom: {
          fileValue: {
            required: () => '请上传文件',
          },
        },
      },
      previewList: [],
      imgType: ['png', 'jpg', 'jpeg', 'gif', 'svg', 'psd', 'webp'],
      fileList: [],
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      },
    },
    index: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    console.log(this.question)
  },
  mounted() {
    this.$validator.localize('zh_CN', this.rule)
    if (this.question.v_answer) {
      console.log(this.question.v_answer.files)
      // 图片
      const fileList = this.question.v_answer.files
        .filter((item) => {
          return this.imgType.includes(item.fileName.split('.').pop())
        })
        .map((item) => {
          return {
            url: item.path,
            fileId: item.tenantId,
            filePath: item.path,
            fileName: item.fileName,
          }
        })
      let requests = [];
      fileList.forEach(item => {
        requests.push(this.downFile(item));
      });
      Promise.all(requests).then(res => {
        this.previewList = res;
        this.fileValue = this.previewList
        //其他类型文件
        this.fileList = this.question.v_answer.files.filter((item) => {
          return !this.imgType.includes(item.fileName.split('.').pop())
        })
      });
    }
  },
  computed: {
    ...mapGetters(['questionnaireList']),
  },
  watch: {
    fileValue(n) {
      const param = {
        index: this.index,
        v_answered: n && n.length,
      }
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)

      const v_answer = this.getValue()
      console.log(v_answer)
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer,
      })
    },
  },
  methods: {
    getValue() {
      let files = this.fileValue.map((item) => {
        return {
          tenantId: item.fileId,
          fileId: item.fileId,
          path: item.filePath,
          fileName: item.fileName,
        }
      })
      return {
        tenantId: this.question.tenantId,
        type: 'file',
        options: [],
        files,
      }
    },
    validate() {
      return this.$validator.validate()
    },
    // 上传图片
    uploadFn() {
      this.$refs['browseImage'].browse()
    },
    uploadDelete(item, index) {
      this.previewList.splice(index, 1)
    },
    onSuccess(data) {
      console.log(data, 'data.imgs')
      // 检查图片上传数量
      if (
        this.previewList.length + data.length >
        this.question.selectRangeMax
      ) {
        new this.$Toast({
          text: `上传文件最多${this.question.selectRangeMax}个`,
          duration: 2000,
        })
        return
      }
      const loading = new this.$Loading()
      Promise.all(
        data.map((item) =>
          this.requestUploadFile(item.file).then((res) => {
            console.log(res)
            this.previewList.push({
              url: item.tempUrl,
              fileId: res.fileId,
              filePath: res.path,
              fileName: item.name,
            })
          })
        )
      )
        .then(() => {
          this.fileValue = this.previewList
          console.log(this.fileValue)
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
    requestUploadFile(file) {
      if (this.ssdpRequestDtgw1) {
        let param = new FormData()
        param.append('file', file)
        param.append('userCode', this.user ? this.user.ldap : '')
        param.append('category', 'form')
        return this.ssdpRequestDtgw1({
          code: 'survey_upload',
          headers: {
            's-crc-tpl-code': 'EMAP_FILE_UPLOAD',
            'content-type':'multipart/form-data'
          },
          data: param,
        })
          .then(
            ({
              data: {
                RESPONSE: { RETURN_CODE, RETURN_DATA, RETURN_DESC },
              },
            }) => {
              if (!['S000A000', 'S0A00000', 'S1A00000'].includes(RETURN_CODE)) {
                return Promise.reject(typeof RETURN_DESC === 'string' ? RETURN_DESC : RETURN_DESC.RETURN_DESC);
              } else {
                return Promise.resolve(
                  RETURN_DATA ? JSON.parse(Base64.decode(RETURN_DATA)) : RETURN_DATA
                );
              }
            }
          )
          .catch((err) => {
            console.error('上传失败', err)
            var msg =
              err && err.RETURN_DESC ? err.RETURN_DESC : '上传失败，请稍后重试！'
            new this.$Dialog({
              title: '温馨提示',
              text: msg,
              theme: 'ios',
              isConfirm: false,
            })
          })
      } else {
        return Promise.resolve({
          fileId: 'fileId',
          filePath: 'filePath'
        });
      }
    },
    openFile(filename, atturl) {
      let fileType = this.getFileType(filename)
      if (this.platform === 3) {
        this.onPreviewAttachment(fileType, atturl)
      } else {
        this.openFileWithGETMethod(filename, atturl)
      }
    },
    openFileWithGETMethod(filename, atturl) {
      console.log(atturl)
      atturl &&
        crh.openFileWithGETMethod({
          param: {
            fileunid: md5(filename),
            file_name: filename,
            download_url: atturl,
            model_name: 'unknow',
            file_encrypt_type: '0',
          },
        })
    },
    onPreviewAttachment(fileType, atturl) {
      const loading = new this.$Loading()
      // atturl &&
      //   jssdk('biz.util.openDocument', {
      //     url: atturl,
      //     fileType,
      //   })
      //     .then(() => {
      //       loading.close()
      //     })
      //     .catch((err) => {
      //       loading.close()
      //       console.log(err)
      //       new this.$Dialog({
      //         title: '温馨提示',
      //         text: '暂不支持打开此格式的文件',
      //         theme: 'ios',
      //         isConfirm: false,
      //       })
      //     })
      atturl &&
        window.tt.openDocument({
          filePath: atturl,
          fileType,
          success(res) {
            console.log(JSON.stringify(res));
            loading.close()
          },
          fail(res) {
            console.log(`openDocument fail: ${JSON.stringify(res)}`);
            loading.close()
            new this.$Dialog({
              title: '温馨提示',
              text: '暂不支持打开此格式的文件',
              theme: 'ios',
              isConfirm: false,
            })
          },
        });
    },
    getFileType(name) {
      return name.split('.').pop()
    },
    // 下载文件
		downFile(item) {
			return this.ssdpRequestDtgw1({
        code: 'survey_download',
        headers: {
          's-crc-tpl-code': 'EMAP_FILE_DOWN',
          'content-type':'application/json',
        },
        params: {
          fileId: item.fileId
        },
        responseType: "blob",
        isUpload: false,
      })
      .then((res) => {
        const blobUrl = URL.createObjectURL(res.data);
        return Promise.resolve({
          ...item,
          url: blobUrl
        })
      });
		}
  },
}
